import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {AppSettings} from "../app.settings";
import {Base2Service} from "./base2.service";
import {ResponseApi} from "./response/response";
import {Agent, Permission, Role} from "../models";
import {Filter} from "./http.service";
import {Response} from "@angular/http";

@Injectable()
export class AgentsService extends Base2Service {
    getUserData():Observable<any>{
        return this.request<any>("GET",AppSettings.apiUrl + 'agents/self')
    }

    getAgentTreeAll(filter: Filter): Observable<ResponseApi> {
        filter.fio = filter.fio ? filter.fio.trim() : "";
        return this.request<ResponseApi>("POST", AppSettings.apiUrl + 'agents/treeAll/' + filter.Id,{page: filter.page,searchString: filter.fio, onlyEnabled:filter.onlyEnabled});
    }

    getAgentTreeFull(agentId: number, onlyEnabled:boolean): Observable<ResponseApi> {
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'agents/treeFull/' + agentId+`/${onlyEnabled}`);
    }

    getAgent(id: number): Observable<ResponseApi> {
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'agents/' + id);
    }

    getV_Agent(id: number): Observable<ResponseApi> {

        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'agents/v/' + id);
    }

    getStatusesAllList(): Observable<ResponseApi> {
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'statuses/all');
    }

    getCategories(): Observable<ResponseApi> {
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'agents/category');
    }

    getAgents(): Observable<ResponseApi> {
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'agents');
    }

    getRoles(): Observable<ResponseApi> {
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'roles');
    }

    changeMultiRole(role: number, agentsArray: number[]) {
        return this.request<ResponseApi>("PUT", AppSettings.apiUrl + 'agents/multirole/' + role + '', JSON.stringify(agentsArray));
    }

    getAgentsByFilterViews(filter: Filter): Observable<ResponseApi> {
        return this.request<ResponseApi>("POST", AppSettings.apiUrl + 'agents/v/', JSON.stringify(filter));
    }

    updateAgent(agent: Agent): Observable<ResponseApi> {
        return this.request<ResponseApi>("PUT", `${AppSettings.apiUrl}agents/${agent.Id}`, JSON.stringify(agent));
    }

    addAgent(agent: Agent): Observable<ResponseApi> {
        return this.request<ResponseApi>("POST", AppSettings.apiUrl + 'agents/add', JSON.stringify(agent));
    }

    getStatusesAgents(): Observable<ResponseApi> {
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'statuses/181');
    }

    getAgentsByFilter(filter: Filter): Observable<ResponseApi> {
        return this.request<ResponseApi>("POST", AppSettings.apiUrl + 'agents', JSON.stringify(filter));
    }

    getAgentTreeByFilter(agentId: number, filter: any): Observable<ResponseApi> {
        return this.request<ResponseApi>("POST", AppSettings.apiUrl + 'agents/tree/' + agentId, JSON.stringify(filter));
    }

}
